/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_LcpInputs */

const en_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const ar_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const bn_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const de_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const es_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const fr_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const pt_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const zh_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const tr_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const ru_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

const pl_svchip_lcp = /** @type {(inputs: Svchip_LcpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LCP`)
};

/**
* | output |
* | --- |
* | "LCP" |
*
* @param {Svchip_LcpInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_lcp = /** @type {((inputs?: Svchip_LcpInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_LcpInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_lcp(inputs)
	if (locale === "bn") return bn_svchip_lcp(inputs)
	if (locale === "de") return de_svchip_lcp(inputs)
	if (locale === "es") return es_svchip_lcp(inputs)
	if (locale === "fr") return fr_svchip_lcp(inputs)
	if (locale === "pt") return pt_svchip_lcp(inputs)
	if (locale === "zh") return zh_svchip_lcp(inputs)
	if (locale === "tr") return tr_svchip_lcp(inputs)
	if (locale === "ru") return ru_svchip_lcp(inputs)
	if (locale === "pl") return pl_svchip_lcp(inputs)
	return en_svchip_lcp(inputs)
});